import { forwardRef, type Ref, type SVGProps } from "react";

function SvgTiersShiftBoost(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={100}
      height={68}
      viewBox="0 0 99 68"
      {...props}
    >
      <defs>
        <clipPath id="TiersShiftBoost_svg__a">
          <path d="M21 5h57v58H21Zm0 0" />
        </clipPath>
        <clipPath id="TiersShiftBoost_svg__b">
          <path d="M49.5 5.668c15.531 0 28.125 12.684 28.125 28.332S65.031 62.332 49.5 62.332 21.375 49.648 21.375 34 33.969 5.668 49.5 5.668m0 0" />
        </clipPath>
        <clipPath id="TiersShiftBoost_svg__d">
          <path d="M41 23h17v22H41Zm0 0" />
        </clipPath>
        <clipPath id="TiersShiftBoost_svg__e">
          <path d="M49.5 5.668c15.531 0 28.125 12.684 28.125 28.332S65.031 62.332 49.5 62.332 21.375 49.648 21.375 34 33.969 5.668 49.5 5.668m0 0" />
        </clipPath>
        <linearGradient
          id="TiersShiftBoost_svg__c"
          x1={88}
          x2={88}
          y1={10}
          y2={110}
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: "#adf3c7",
              stopOpacity: 1,
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#f6f3f1",
              stopOpacity: 1,
            }}
          />
        </linearGradient>
      </defs>
      <g clipPath="url(#TiersShiftBoost_svg__a)">
        <g clipPath="url(#TiersShiftBoost_svg__b)">
          <path
            d="M138 60c0-27.615-22.389-49.998-50-49.998S38 32.385 38 60s22.389 49.998 50 49.998S138 87.615 138 60Zm0 0"
            style={{
              fill: "none",
              strokeWidth: 20,
              strokeLinecap: "butt",
              strokeLinejoin: "miter",
              stroke: "url(#TiersShiftBoost_svg__c)",
              strokeMiterlimit: 4,
            }}
            transform="scale(.5625 .56667)"
          />
        </g>
      </g>
      <g clipPath="url(#TiersShiftBoost_svg__d)">
        <g clipPath="url(#TiersShiftBoost_svg__e)">
          <path
            d="M94.597 45.227c.882-2.702-2.451-4.832-4.375-2.667L75.354 59.29c-1.52 1.71-.36 4.508 1.91 4.508h7.16c.243 0 .43.248.354.51l-3.216 10.506c-.833 2.716 2.507 4.784 4.396 2.612L100.66 60.6c1.5-1.717.34-4.488-1.924-4.488h-7.16c-.243 0-.437-.255-.347-.524Zm0 0"
            style={{
              fill: "none",
              strokeWidth: 1,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              stroke: "#0c1c43",
              strokeOpacity: 1,
              strokeMiterlimit: 4,
            }}
            transform="scale(.5625 .56667)"
          />
        </g>
      </g>
      <path
        d="M48 10.499c10.77 0 19.5 8.734 19.5 19.501S58.77 49.501 48 49.501 28.5 40.767 28.5 30 37.23 10.499 48 10.499Zm0 0"
        style={{
          fillRule: "nonzero",
          fill: "#0d2b57",
          fillOpacity: 1,
          strokeWidth: 1,
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          stroke: "#fff",
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        transform="scale(.5625 .56667)"
      />
      <path
        d="M48 22.638v-1.64m0 16.364v1.64m3.465-13.91c-.694-.979-1.986-1.64-3.465-1.64h-.444C45.59 23.451 44 24.753 44 26.36v.131c0 1.145.792 2.2 2.049 2.71L49.95 30.8c1.257.51 2.049 1.564 2.049 2.709 0 1.675-1.66 3.04-3.708 3.04H48c-1.48 0-2.77-.662-3.465-1.64"
        style={{
          fill: "none",
          strokeWidth: 1,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          stroke: "#fff",
          strokeOpacity: 1,
          strokeMiterlimit: 4,
        }}
        transform="scale(.5625 .56667)"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTiersShiftBoost);
export default ForwardRef;
